<script setup>
import {ref, computed, getCurrentInstance} from 'vue'
import { useI18n } from 'vue-i18n'
import { saveLocale, getLocaleName } from '@/utils/locale'
import { onMounted, onUnmounted } from 'vue'
import LocaleFlag from "@/components/locale/LocaleFlag.vue";

const { proxy } = getCurrentInstance()
const auth = proxy.$auth

const { locale, availableLocales } = useI18n()

const isOpen = ref(false)


const otherLocales = computed(() =>
    availableLocales.filter((l) => l !== locale.value)
)

const onLocaleChange = (newLocale) => {
    locale.value = newLocale
    saveLocale(newLocale)
    if (auth.isLoggedIn()) {
        axios.post('/profile/locale', { locale: newLocale })
    }
    isOpen.value = false
}

const toggleOpen = () => {
    isOpen.value = !isOpen.value
}

const handleOutsideClick = (e) => {
    if (!e.target.closest('.locale-changer')) isOpen.value = false
}
onMounted(() => document.addEventListener('click', handleOutsideClick))
onUnmounted(() => document.removeEventListener('click', handleOutsideClick))
</script>

<template>
    <div class="locale-changer">
        <div class="locale-tile" @click="toggleOpen">
            <span class="locale-flag"><LocaleFlag :locale="locale"/></span>
        </div>

        <transition name="dropdown">
            <div v-if="isOpen" class="locale-dropdown">
                <div
                    v-for="loc in otherLocales"
                    :key="`locale-${loc}`"
                    class="locale-option"
                    @click="onLocaleChange(loc)"
                >
                    <LocaleFlag :locale="loc"/>
                    <span class="locale-label">{{ getLocaleName(loc) }}</span>
                </div>
            </div>
        </transition>
    </div>
</template>

<style scoped>

.locale-changer {
    position: relative;
    display: inline-block;
    user-select: none;
}

.locale-tile {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    font-weight: 600;

    .fi {
        border: 1px solid var(--bulma-border);
    }
}


.locale-dropdown {
    position: absolute;
    bottom: calc(100% + 6px);
    left: 0;
    background-color: var(--bulma-scheme-main-bis);
    border-radius: 10px;
    box-shadow: var(--bulma-shadow);
    overflow: hidden;
    z-index: 100;
    min-width: 100%;
}

.locale-option {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    cursor: pointer;
    font-weight: 500;
    transition: background 0.15s;
}

.locale-option:hover {
    background: var(--bulma-link);
}

.locale-flag {
    font-size: 20px;
}

.locale-label {
    font-size: 14px;
}

.dropdown-enter-active,
.dropdown-leave-active {
    transition: opacity 0.15s, transform 0.15s;
}

.dropdown-enter-from,
.dropdown-leave-to {
    opacity: 0;
    transform: translateY(-6px);
}
</style>
